"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainNavWrapper = exports.MainNavInner = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HomePageToggle = require("../../../HomePageToggle/HomePageToggle.styles");
var _ServicesNav = require("../ServicesNav/ServicesNav.style");
var _sharedStyles = require("../sharedStyles");
const MainNavWrapper = exports.MainNavWrapper = _styledComponents.default.div.withConfig({
  displayName: "Mainstyle__MainNavWrapper",
  componentId: "sc-c7scp2-0"
})(["width:100%;height:", "px;display:block;"], _sharedStyles.headerHeight);
const MainNavInner = exports.MainNavInner = _styledComponents.default.div.withConfig({
  displayName: "Mainstyle__MainNavInner",
  componentId: "sc-c7scp2-1"
})(["position:relative;display:flex;height:100%;align-items:center;", "{margin-right:20px;margin-left:auto;}", " + ", "{margin-left:0;}"], _HomePageToggle.HomePageToggleContainer, _HomePageToggle.HomePageToggleContainer, _ServicesNav.ServicesNavStyle);